const permissionActionTypes = {
  SET_PERMISSION_ISSUE_STATUS: "SET_PERMISSION_ISSUE_STATUS",
  SET_DOES_NOT_USER_CASE: "SET_DOES_NOT_USER_CASE",
  SET_MANAGER_ROLE: "SET_MANAGER_ROLE",
};

export default permissionActionTypes;
